/* src/app/modules/shared/components/header-column/header-column-variant-price/header-column-variant-price.component.scss */
app-header-column-variant-price {
  display: contents;
}
/*# sourceMappingURL=header-column-variant-price.component.css.map */
